// extracted by mini-css-extract-plugin
export default {"leftSide":"LeftSide_leftSide__+gxLl"};